export const apps = [
    {
        id: 'gnocchi',
        url: 'https://gnocchi.biscuits.club',
        name: 'Gnocchi',
        description: 'Organize your weekly cooking',
        mainImageUrl: 'https://gnocchi.biscuits.club/og-image.png',
        iconPath: 'android-chrome-512x512.png',
        size: 4,
        devOriginOverride: 'http://localhost:6220',
        demoVideoSrc: '/videos/gnocchi-compressed.mp4',
        paidFeatures: [
            {
                imageUrl: '/images/gnocchi/scanner.png',
                title: 'Recipe Scanner',
                description: 'Scan web recipes to create a personal copy. Add notes, make changes, and collaborate on cooking with other plan members.',
            },
            {
                imageUrl: '/images/gnocchi/groceries-collaboration.png',
                title: 'Collaborative Groceries',
                description: 'Share your groceries list with other plan members and stay on the same page. Shopping gets more efficient with realtime presence and progress updates.',
                family: true,
            },
            {
                imageUrl: '/images/gnocchi/recipe-collaboration.png',
                title: 'Sous Chef Mode',
                description: 'Team up with other plan members to cook a recipe together. Assign steps and track progress with instant updates.',
                family: true,
            },
        ],
        paidDescription: 'Your personal cooking app becomes a family groceries list and recipe box.',
        theme: 'lemon',
        domainRoutes: (planId, ctx) => {
            if (ctx.tld.startsWith('localhost')) {
                return `http://localhost:6402/p/${planId}`;
            }
            return `https://recipes.gnocchi.${ctx.tld}/p/${planId}`;
        },
    },
    {
        id: 'trip-tick',
        url: 'https://trip-tick.biscuits.club',
        name: 'Trip Tick',
        description: 'The smartest packing list for your next trip',
        iconPath: 'icon.png',
        size: 2,
        devOriginOverride: 'http://localhost:6221',
        demoVideoSrc: '/videos/trip-tick-compressed.mp4',
        paidFeatures: [
            {
                imageUrl: '/images/trip-tick/weather.png',
                title: 'Weather Forecast',
                description: 'Get weather forecasts for your destination over the duration of your trip.',
            },
            {
                imageUrl: '/images/trip-tick/conditions.png',
                title: 'Powerful Conditions',
                description: 'Define conditions for packing list items based on predicted weather to make sure you have everything you need.',
            },
        ],
        paidDescription: 'Now everyone can be on the same page when packing. Plus, get a weather forecast and more powerful trip planning tools.',
        theme: 'eggplant',
    },
    {
        id: 'wish-wash',
        demoVideoSrc: '',
        description: 'TODO',
        devOriginOverride: 'http://localhost:6222',
        iconPath: 'icon.png',
        name: 'Wish Wash',
        paidDescription: 'TODO',
        paidFeatures: [],
        url: 'https://wish-wash.biscuits.club',
        prerelease: true,
        theme: 'eggplant',
        domainRoutes: (listId, ctx) => {
            if (ctx.tld.startsWith('localhost')) {
                return `http://localhost:6401/l/${listId}`;
            }
            return `https://lists.wish-wash.${ctx.tld}/l/${listId}`;
        },
    },
    {
        id: 'star-chart',
        demoVideoSrc: '',
        description: 'TODO',
        devOriginOverride: 'http://localhost:6224',
        iconPath: 'icon.png',
        name: 'Star Chart',
        paidDescription: 'TODO',
        paidFeatures: [],
        url: 'https://star-chart.biscuits.club',
        prerelease: true,
        theme: 'blueberry',
    },
    {
        id: 'names',
        name: 'Names',
        iconPath: 'icon.png',
        description: "Remember people's names",
        url: 'https://names.biscuits.club',
        devOriginOverride: 'http://localhost:6227',
        demoVideoSrc: '/videos/names-compressed.mp4',
        paidDescription: 'Sync names with your devices and share with family, plus location-based search',
        paidFeatures: [
            {
                imageUrl: '',
                title: 'Location-Based Search',
                description: 'Automatically record where you are when you add a name, so you can search later by where you met someone.',
            },
            {
                imageUrl: '',
                title: 'Family Sharing',
                description: 'Share names with family members so you can all remember together.',
                family: true,
            },
            {
                imageUrl: '',
                title: 'Sync Across Devices',
                description: 'Access your names on all your devices.',
            },
        ],
        prerelease: false,
        theme: 'leek',
    },
    {
        id: 'palette',
        demoVideoSrc: '/videos/palette-compressed.mp4',
        description: 'Paint what you see',
        devOriginOverride: 'http://localhost:6226',
        iconPath: 'icon.png',
        name: 'Palette',
        paidDescription: 'Sync your projects across all your devices',
        paidFeatures: [],
        url: 'https://palette.biscuits.club',
        prerelease: false,
        theme: 'lemon',
    },
    {
        id: 'mood',
        demoVideoSrc: '',
        description: 'Track and improve your mood',
        devOriginOverride: 'http://localhost:6228',
        iconPath: 'icon.png',
        name: 'Mood',
        paidDescription: 'TODO',
        paidFeatures: [],
        url: 'https://mood.biscuits.club',
        prerelease: true,
        theme: 'blueberry',
    },
    {
        id: 'floorplan',
        description: '',
        devOriginOverride: 'http://localhost:6229',
        iconPath: 'icon.png',
        name: 'Floorplan',
        paidDescription: 'TODO',
        paidFeatures: [],
        url: 'https://floorplan.biscuits.club',
        prerelease: true,
        theme: 'tomato',
        demoVideoSrc: '',
    },
];
export const appIds = apps.map((app) => app.id);
export function isValidAppId(appId) {
    return appIds.includes(appId);
}
export const appsById = Object.fromEntries(apps.map((app) => [app.id, app]));
export function getAppUrl(app) {
    if (import.meta.env.DEV) {
        return app.devOriginOverride;
    }
    return app.url;
}
export const visibleApps = apps.filter((app) => !app.prerelease);
//# sourceMappingURL=index.js.map